import SignupForm from './SignupForm/index';
export default SignupForm;
